import { Service } from '@angular/core';
import { State } from '@ngxs/store';
import { CollectionDataServiceBase } from '@portal-core/data/collection/services/collection-data.service.base';
import { CollectionStateBase } from '@portal-core/data/collection/services/collection-state.base';
import { CollectionStateSelectors } from '@portal-core/data/collection/services/collection-state-selectors.decorator';
import { SearchQueryReport } from '@portal-core/output-analytics/models/output-analytics-search-query-report.model';

@CollectionStateSelectors({
  stateType: SearchQueryReportState
})
@State<SearchQueryReportState>({
  name: SearchQueryReportState.source,
})
@Service({ autoProvided: false })
export class SearchQueryReportState extends CollectionStateBase {
  static override source = 'SearchQueryReports';
  getSource(): string {
    return SearchQueryReportState.source;
  }
}

@Service()
export class SearchQueryReportDataService extends CollectionDataServiceBase<SearchQueryReport> {
  protected readonly stateType = SearchQueryReportState;
}
